'use client';

// imports
import { useEffect, useState } from 'react';

// components
import ITSPicture from '@/components/ITSPicture/ITSPicture';

// styles
import styles from './WallofShowPostersBackgroundImage.module.scss';

interface WallofShowPostersBackgroundImageProps {
  className?: string;
  usage: 'pageBackground' | 'heroBackground' | 'heroSquareBackground' | 'rowBackground';
}

const squareAspectRatioSources = [
  {
    minWidth: 1700,
    width: 1700,
    height: 1299,
  },
  {
    minWidth: 1440,
    width: 1440,
    height: 1100,
  },
  {
    minWidth: 1280,
    width: 1280,
    height: 782,
  },
  {
    minWidth: 1024,
    width: 1024,
    height: 576,
  },
  {
    minWidth: 768,
    width: 768,
    height: 1363,
  },
  {
    minWidth: 500,
    width: 500,
    height: 887,
  },
  {
    minWidth: 320,
    width: 320,
    height: 568,
  },
]

const halfAspectRatioSources = [
  {
    minWidth: 1700,
    width: 1700,
    height: 699,
  },
  {
    minWidth: 1440,
    width: 1440,
    height: 593,
  },
  {
    minWidth: 1280,
    width: 1280,
    height: 527,
  },
  {
    minWidth: 1024,
    width: 1024,
    height: 421,
  },
  {
    minWidth: 768,
    width: 768,
    height: 316,
  },
  {
    minWidth: 500,
    width: 500,
    height: 206,
  },
  {
    minWidth: 320,
    width: 320,
    height: 202,
  },
]

const WallofShowPostersBackgroundImage = (props: WallofShowPostersBackgroundImageProps) => {
  const { className, usage } = props;
  // The fallback image does not have the most up-to-date show posters, so we only use it if we don't have a CS image
  const fallbackImage = "https://image.pbs.org/webobjects/device-activation-show-posters.png";
  const [imagePath, setImagePath] = useState('');

  useEffect(() => {
    const getImage = async  () => {
      try {
        const url = `/api/v1/wall-of-show-posters`;
        const results = await fetch(url);
        const data = await results.json() as string;
        setImagePath(data)
      } catch (_error) {
        setImagePath(fallbackImage)
      }
    }
    getImage();
  }, [setImagePath])

  let classNames = styles.hero_background;
  let sources = halfAspectRatioSources;

  switch (usage) {
    case 'pageBackground':
      classNames = styles.page_background;
      sources = squareAspectRatioSources;
      break;
    case 'rowBackground':
      classNames = styles.row_background;
      break;
    case 'heroSquareBackground':
      classNames = styles.hero_square_background;
      sources = squareAspectRatioSources;
      break;
    case 'heroBackground':
    default:
      break;
  }

  if (className) {
    classNames += ` ${className}`;
  }

  if (imagePath === '') {
    return null;
  }

  return (
    <ITSPicture
      src={imagePath}
      alt={""}
      width={1440}
      height={810}
      resizeWithCrop={true}
      sources={sources}
      ariaHidden={true}
      className={classNames}
    />
  );
};

export default WallofShowPostersBackgroundImage;
